import { render, staticRenderFns } from "./ObjectsGroupModal.vue?vue&type=template&id=5e1ff9ea&"
import script from "./ObjectsGroupModal.vue?vue&type=script&lang=ts&"
export * from "./ObjectsGroupModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports